import { useEffect, useRef } from 'react';

export const useReport = (key: string | undefined, send: () => void): void => {
  const reported = useRef<string | undefined>(undefined);
  const sendRef = useRef(send);
  sendRef.current = send;

  useEffect(() => {
    if (key === undefined || reported.current === key) return;
    reported.current = key;
    sendRef.current();
  }, [key]);
};
